import vue from 'vue'
import {
  getAttestationPage,
  getAttestationDetails, getAttestationStart, getAttestationOut,
} from "../../../services/attestation";
import {Message} from "element-ui";

const state = {
  dataPages: [],
  total: 0,
  dataDetails: {},
  paginationInit: {current: 1, size: 10},
  detailVisible: false,
};

const getters = {
  dataPages: () => state.dataPages,
  total: () => state.total,
  paginationInit: () => state.paginationInit,
  dataDetails: () => state.dataDetails,
  detailVisible: () => state.detailVisible,
};

const actions = {
  //分页
  getAttestationPage({commit, dispatch}, objc) {
    getAttestationPage(objc).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'dataPages', update: res.data.records});
        commit('updateState', {state: 'total', update: res.data.total});
      } else {
        commit('updateState', {state: 'dataPages', update: []});
        commit('updateState', {state: 'total', update: 0});
      }
    })
  },
  //详情
  getAttestationDetails({commit, dispatch}, objc) {
    getAttestationDetails(objc).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'dataDetails', update: res.data});
      }
    })
  },
  //同意
  getAttestationStart({commit, dispatch}, objc) {
    getAttestationStart(objc).then((res) => {
      if (res.code === 0) {
        dispatch('getAttestationPage', state.paginationInit);
      }
    })
  },
  //驳回
  getAttestationOut({commit, dispatch}, objc) {
    getAttestationOut(objc).then((res) => {
      if (res.code === 0) {
        dispatch('getAttestationPage', state.paginationInit);
      }
    })
  },
};

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/attestation/modules/authentication.js